import { render, staticRenderFns } from "./circleFriends.vue?vue&type=template&id=7dc83ae3&scoped=true&"
import script from "./circleFriends.vue?vue&type=script&lang=js&"
export * from "./circleFriends.vue?vue&type=script&lang=js&"
import style0 from "./circleFriends.vue?vue&type=style&index=0&id=7dc83ae3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc83ae3",
  null
  
)

export default component.exports